import styled from 'styled-components';

export const NewProjectContainer = styled.div``;

export const BannerContainer = styled.div`
  .hefesto-banner {
    top: 6%;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptopL}) {
      top: 18%;
    }
  }
`;

export const SendProjectBody = styled.div`
  width: 100%;
  height: 25.25rem;
  display: flex;
  justify-content: space-between;
`;

export const UploadedFilesList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 100%;
  overflow-y: auto;
  border-right: 2px solid ${({ theme }) => theme.colors.gray2};
  color: ${({ theme }) => theme.colors.grayDark2};
  padding: 0.5rem 1rem;

  & > div.file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    cursor: pointer;
    transition: background-color 0.25s ease-in;

    &.selected {
      background-color: #dce9ff;
    }

    & > span.filename {
      font-size: 1rem;
      margin-right: 0.5rem;
      color: ${({ theme }) => theme.colors.grayDark4};
      display: block;
      width: 99%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & > span.icon svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const SendProjectConfig = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  padding: 0.5rem 1rem;

  & > span.title {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    margin-bottom: 0.875rem;
  }
`;

export const Subtitle = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  margin-bottom: 0.875rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  & > span {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-size: 1rem;
  }
`;

export const SendProjectContent = styled.div`
  width: 100%;
  margin-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & > span.required-fields-message {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
`;
